import { render } from "./ValueRoadMapSetup.vue?vue&type=template&id=67c9f802"
import script from "./ValueRoadMapSetup.vue?vue&type=script&lang=js"
export * from "./ValueRoadMapSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__